import React from 'react'
import Switch from '@react/react-spectrum/Switch'

export default function SettingsSwitch({ label, checked, onChange }) {
  return (
    <div className='SettingsForm__switch'>
      <Switch checked={checked} onChange={onChange} />
      <label>{label}</label>
    </div>
  )
}
